module.exports = __webpack_public_path__ + "static/media/StorePageHeader.518be706.png";